module.exports = __webpack_public_path__ + "img/need-help.55e8261d.svg";